import axios from "axios";
import { server } from "../../server";

export const createParentColor = (name, images) => async (dispatch) => {
  try {
    dispatch({ type: "createColorParentRequest" });

    const { data } = await axios.post(
      `${server}/colorparent/create-color`,
      { name, images },
      {
        withCredentials: true,
      }
    );

    dispatch({
      type: "createColorParentSuccess",
      payload: data.color,
    });
  } catch (error) {
    dispatch({
      type: "createColorParentFail",
      payload:
        error.response?.data?.message || error.message || "Create color error",
    });
  }
};

export const getAllParentColors = () => async (dispatch) => {
  try {
    dispatch({ type: "getAllColorParentsRequest" });

    const { data } = await axios.get(`${server}/colorparent/get-all-colors`, {
      withCredentials: true,
    });

    dispatch({
      type: "getAllColorParentsSuccess",
      payload: data.colors,
    });
  } catch (error) {
    dispatch({
      type: "getAllColorParentsFail",
      payload:
        error.response?.data?.message || error.message || "Fetch color error",
    });
  }
};

export const getOneParentColor = (id) => async (dispatch) => {
  try {
    dispatch({ type: "getOneColorParentRequest" });

    const { data } = await axios.get(`${server}/colorparent/get-color/${id}`, {
      withCredentials: true,
    });

    dispatch({
      type: "getOneColorParentSuccess",
      payload: data.color,
    });
  } catch (error) {
    dispatch({
      type: "getOneColorParentFail",
      payload:
        error.response?.data?.message || error.message || "Get color error",
    });
  }
};

export const updateParentColor =
  (id, { name, imagesToDelete, newImages }) => async (dispatch) => {
    try {
      dispatch({ type: "updateColorParentRequest" });

      const { data } = await axios.put(
        `${server}/colorparent/update-color/${id}`,
        {
          name,
          imagesToDelete, 
          newImages,
        },
        {
          withCredentials: true,
        }
      );

      dispatch({
        type: "updateColorParentSuccess",
        payload: data.color,
      });
    } catch (error) {
      dispatch({
        type: "updateColorParentFail",
        payload:
          error.response?.data?.message || error.message || "Update color error",
      });
    }
  };

export const deleteParentColor = (id) => async (dispatch) => {
  try {
    dispatch({ type: "deleteColorParentRequest" });

    const { data } = await axios.delete(
      `${server}/colorparent/delete-color/${id}`,
      {
        withCredentials: true,
      }
    );

    dispatch({
      type: "deleteColorParentSuccess",
      payload: data.message,
    });
  } catch (error) {
    dispatch({
      type: "deleteColorParentFail",
      payload:
        error.response?.data?.message || error.message || "Delete color error",
    });
  }
};

export const clearErrors = () => async (dispatch) => {
  dispatch({
    type: "clearErrors",
  });
};
